import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Box,
    Typography,
    Container,
    useTheme,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Grid,
    FormHelperText,
    FormControl,
} from "@mui/material";
import PageHeading from "../../layout/PageHeading";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { clearCart } from "../../redux/actions/cartActions";
import stateCityData from "../../data/stateCity.json";
import { useNavigate } from "react-router-dom";

const CheckOut = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Product = useSelector(state => state?.counter);
    const theme = useTheme();
    console.log("Product.productsProduct.products", Product.products);

    const [formData, setFormData] = useState({
        name: "", email: "", phone: "",
        address1: "", address2: "", landmark: "", alternatephone: "",
        pincode: "", state: "Gujarat", city: "Surat", paymentmode: ""
    });
    const [errors, setErrors] = useState({});
    const [cities, setCities] = useState([]);
    const [shippingCharge, setShippingCharge] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (formData.state && stateCityData[formData.state]) {
            setCities(stateCityData[formData.state]);
            if (!stateCityData[formData.state].includes(formData.city)) {
                setFormData(prev => ({ ...prev, city: "" }));
            }
        } else {
            setCities([]);
            setFormData(prev => ({ ...prev, city: "" }));
        }
    }, [formData.state]);

    useEffect(() => {
        if (stateCityData["Gujarat"]) {
            setCities(stateCityData["Gujarat"]);
        }
    }, []);

    useEffect(() => {
        let charge = 0;
        if (formData.paymentmode === "cash") {
            charge = 150 * Product?.products?.length;
        } else if (formData.paymentmode === "online") {
            charge = formData.state === "Gujarat" ? 30 * Product?.products?.length : 80 * Product?.products?.length;
        }
        setShippingCharge(charge);
    }, [formData.state, formData.paymentmode]);

    const validate = () => {
        let tempErrors = {};
        const phonePattern = /^[0-9]{10}$/;
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.phone || !phonePattern.test(formData.phone)) tempErrors.phone = "Enter valid 10-digit phone number";
        // if (!phonePattern.test(formData.alternatephone)) tempErrors.alternatephone = "Enter valid 10-digit Alternate Phone number";
        if (!formData.address1) tempErrors.address1 = "Address line 1 is required";
        if (!formData.pincode) tempErrors.pincode = "Pincode is required";
        if (!formData.landmark) tempErrors.landmark = "Landmark is required";
        if (!formData.paymentmode) tempErrors.paymentmode = "Payment mode is required";
        if (!formData.state) tempErrors.state = "State is required";
        if (!formData.city) tempErrors.city = "City is required";

        if (!formData.email) {
            tempErrors.email = "Email is required";
        } else if (
            !/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(formData.email)
        ) {
            tempErrors.email = "Please enter a valid Gmail address (e.g., user@gmail.com)";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleRadioChange = (e) => {
        setFormData({ ...formData, paymentmode: e.target.value });
    };

    useEffect(() => {
        if (!Product?.products || Product?.products?.length === 0) {
            navigate("/shop");
        }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;

        if (!Product?.products?.length) {
            Swal.fire({
                icon: 'error',
                title: 'Cart is Empty!',
                text: 'Please add some products to your cart before checking out.',
                confirmButtonColor: '#8B7355',
            });
            return;
        }

        if (validate()) {
            setLoading(true);
            const totalPrice = JSON.parse(localStorage.getItem("totalPrice")) || [];

            if (formData?.paymentmode === "online") {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BACKEND_APP}/create-order`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ amount: parseInt(totalPrice) + parseInt(shippingCharge) }),
                    });

                    const order = await response.json();
                    console.log("process.env.REACT_APP_RAZORPAY_KEY ", process.env.REACT_APP_RAZORPAY_KEY);
                    console.log("order.amount ", order.amount);
                    console.log("order.currency ", order.currency);

                    const options = {
                        key: "rzp_live_N0tiw6DIbfKfDf",
                        amount: order.amount,
                        currency: order.currency,
                        name: "Jay Khodiyar Fashion",
                        description: "Live Payment",
                        order_id: order.id,
                        handler: async function (response) {
                            const verifyRes = await fetch(`${process.env.REACT_APP_BACKEND_APP}/verify-payment`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(response),
                            });

                            const verifyJson = await verifyRes.json();
                            if (verifyJson.message) {
                                await makeorder();
                            }
                            setLoading(false);
                        },
                        prefill: {
                            name: formData.name,
                            email: formData.email,
                            contact: formData.phone,
                        },
                        theme: { color: "#3399cc" },
                    };

                    const rzp1 = new window.Razorpay(options);
                    rzp1.open();
                } catch (error) {
                    console.error("Payment Error:", error);
                    Swal.fire("Payment Failed", "Something went wrong with the payment.", "error");
                    setLoading(false);
                }
            } else {
                await makeorder();
                setLoading(false);
            }
        }
    };

    const makeorder = async () => {
        try {
            setLoading(true);
            const BuyProduct = Product.products.map((item) => ({
                ...item.product[0],
                count: item.count,
            }));

            let productCountShiping = shippingCharge * BuyProduct.length;

            const formDatas = {
                ...formData,
                BuyProduct,
                productCountShiping,
            };
            console.log("formDatasformDatas", formDatas);
            console.log("shippingChargeshippingCharge", productCountShiping);

            const res = await fetch(`${process.env.REACT_APP_BACKEND_APP}/send-order`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formDatas),
            });

            const resJson = await res.json();
            dispatch(clearCart());
            navigate("/shop");
            localStorage.removeItem("cartData");
            localStorage.removeItem("totalPrice");

            Swal.fire({
                icon: 'success',
                title: 'Order Placed!',
                text: 'Your order has been placed successfully.',
                confirmButtonColor: '#8B7355',
                timer: 3000,
            });

            console.log("Order Response:", resJson);
        } catch (error) {
            console.error("Order Error:", error);
            Swal.fire("Error", "Failed to place the order. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeading title={"Check out"} />
            <Box sx={{ bgcolor: "black", color: "white", px: { md: 8, xs: 2 }, py: { md: 8, xs: 6 } }}>
                <Container maxWidth="md">
                    <Typography variant="h3" sx={{ fontFamily: theme.palette.typography.fontFamily1, fontWeight: 500 }}>
                        Enter to Check out
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        {["name", "email", "phone", "alternatephone", "address1", "address2", "landmark", "pincode"].map((field) => (
                            <Box key={field} sx={{ mt: 3 }}>
                                <TextField
                                    label={field == 'alternatephone' ? "Alternate Phone" : field.charAt(0).toUpperCase() + field.slice(1)}
                                    name={field}
                                    variant="outlined"
                                    fullWidth
                                    value={formData[field]}
                                    onChange={handleChange}
                                    error={!!errors[field]}
                                    helperText={errors[field]}
                                    margin="normal"
                                    InputLabelProps={{ style: { color: '#9a9998' } }}
                                    InputProps={{ style: { color: '#9a9998' } }}
                                    inputProps={
                                        field === "address2" || field === "landmark"
                                            ? { maxLength: 20 }
                                            : undefined
                                    }
                                />
                            </Box>
                        ))}

                        {/* State and City Dropdown */}
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="State"
                                        name="state"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.state}
                                        onChange={handleChange}
                                        error={!!errors.state}
                                        helperText={errors.state}
                                        margin="normal"
                                        InputLabelProps={{ style: { color: '#9a9998' } }}
                                        InputProps={{ style: { color: '#9a9998' } }}
                                        sx={{
                                            mt: 3,
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#171717",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#8B7355",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#8B7355",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="City"
                                        name="city"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.city}
                                        onChange={handleChange}
                                        error={!!errors.city}
                                        helperText={errors.city}
                                        margin="normal"
                                        InputLabelProps={{ style: { color: '#9a9998' } }}
                                        InputProps={{ style: { color: '#9a9998' } }}
                                        sx={{
                                            mt: 3,
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#171717",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#171717",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#171717",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Payment Options */}
                        <FormControl error={!!errors.paymentmode} sx={{ mt: 3 }}>
                            <FormLabel sx={{ fontSize: "18px" }}>Select an option for payment</FormLabel>
                            <RadioGroup sx={{ display: "block" }} onChange={handleRadioChange} value={formData.paymentmode}>
                                <Grid container spacing={4} padding={2}>
                                    <Grid item xs={12} lg={6}>
                                        <FormControlLabel
                                            sx={{ width: "100%", px: 1, py: 1, border: "1px solid #d9d9d9", borderRadius: 2 }}
                                            value="cash"
                                            control={<Radio />}
                                            label="Cash on delivery"
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <FormControlLabel
                                            sx={{ width: "100%", px: 1, py: 1, border: "1px solid #d9d9d9", borderRadius: 2 }}
                                            value="online"
                                            control={<Radio />}
                                            label="Via Google Pay"
                                        />
                                    </Grid>
                                </Grid>
                            </RadioGroup>
                            <FormHelperText>{errors.paymentmode}</FormHelperText>
                        </FormControl>

                        {/* Shipping Info */}
                        {shippingCharge > 0 && (
                            <Typography sx={{ mt: 2 }}>
                                🚚 Shipping Charge: ₹{shippingCharge}
                            </Typography>
                        )}

                        {/* Submit Button */}
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 3,
                                py: 1,
                                px: 4,
                                bgcolor: "#8B7355",
                                fontSize: "18px",
                                "&:hover": { bgcolor: "#6F5B3E" },
                            }}
                            fullWidth
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Check out"}
                        </Button>
                    </form>
                </Container>
            </Box>
        </>
    );
};

export default CheckOut;
